<script>
import { onMount } from 'svelte'
import { Link } from "svelte-routing";
import Nav from "../widget/Navbar.svelte";
const apiURL = 'https://axcora.my.id/pos-x/API/frontend/cons.php';
	let data = [];onMount(async function() {const response = await fetch(apiURL);data = await response.json();});
	
	
</script>
{#each data as item}	
<Nav/>
<div class="row" >
<div class="col-12 col-md-5 p-3 p-md-5">
<div class="p-3 ">
<h1 class="display-4"><a href="/"> {item.title}</a>
</h1>
<h2 class="mt-3">
{item.description}
</h2>
 <p class="mt-3">
          {item.content}
          </p>
		  <Link class="btn btn-dark btn-lg" to="/shop">Shop Now</Link>
</div></div>
<div class="col-12 col-md-7 p-0">
<img class="img-fluid" src="{item.cover}" width="100%" alt="{item.description}"/>
</div>
<div class="col-12 col-md-4 p-0">
<img class="img-fluid" src="{item.sectioncover1}" width="100%" alt="{item.section1}"/>
<div class="p-3 p-md-5">
{item.section1}
</div>
</div>
<div class="col-12 col-md-4 p-0">
<img class="img-fluid" src="{item.sectioncover2}" width="100%" alt="{item.section2}"/>
<div class="p-3 p-md-5">
{item.section2}
</div>
</div>
<div class="col-12 col-md-4 p-0">
<img class="img-fluid" src="{item.sectioncover3}" width="100%" alt="{item.section3}"/>
<div class="p-3 p-md-5">
{item.section3}
</div>
</div>
<div class="col-12 col-md-12 p-0">
<img class="img-fluid" src="{item.footercover}" width="100%" alt="{item.description}"/>
<div class="p-3 p-md-5">
{item.footer}
</div>
</div>
</div>		
        {/each}

